import { render, staticRenderFns } from "./create-businnes-profile.vue?vue&type=template&id=4d18a1d4&scoped=true"
import script from "./create-businnes-profile.vue?vue&type=script&lang=js"
export * from "./create-businnes-profile.vue?vue&type=script&lang=js"
import style0 from "./create-businnes-profile.vue?vue&type=style&index=0&id=4d18a1d4&prod&lang=css"
import style1 from "./create-businnes-profile.vue?vue&type=style&index=1&id=4d18a1d4&prod&lang=css&scoped=true"
import style2 from "./create-businnes-profile.vue?vue&type=style&index=2&id=4d18a1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d18a1d4",
  null
  
)

export default component.exports